/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Hero_SubInputs */

const en_rd_hero_sub = /** @type {(inputs: Rd_Hero_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a public GitHub URL. We score the 11 signals an agent needs before it can work unattended, and flag secrets you left in the tree. No sign-up.`)
};

const id_rd_hero_sub = /** @type {(inputs: Rd_Hero_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempel URL GitHub publik. Kami nilai 11 sinyal yang dibutuhkan agent supaya bisa kerja tanpa ditunggui, sekaligus menandai kunci rahasia yang tertinggal. Tanpa daftar.`)
};

/**
* | output |
* | --- |
* | "Paste a public GitHub URL. We score the 11 signals an agent needs before it can work unattended, and flag secrets you left in the tree. No sign-up." |
*
* @param {Rd_Hero_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_hero_sub = /** @type {((inputs?: Rd_Hero_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Hero_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_hero_sub(inputs)
	return en_rd_hero_sub(inputs)
});